import useUserFeature from "../../hooks/use-user-feature";
import { Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const PlanFeatureButton = ({ feature, ...props }) => {
  const { t } = useTranslation();
  const planFeatureEnabled = useUserFeature(feature);

  return (
    <>
      {planFeatureEnabled ? (
        <Button {...props} />
      ) : (
        <Tooltip title={t("components.planFeatureButton.notAvailable")}>
          <span>
            <Button disabled {...props} />
          </span>
        </Tooltip>
      )}
    </>
  );
};

export default PlanFeatureButton;
